import * as React from "react";
function XlIcon() {
    return React.createElement("path", { d: "M5.8335 35.8335V7.09428H11.2609V3.97461H13.5151V7.09428H26.5492V3.97461H28.75V7.09428H34.1667V35.8335H5.8335ZM7.92745 33.7395H32.0728V16.9767H7.92745V33.7395ZM7.92745 14.8828H32.0728V9.18824H7.92745V14.8828Z", fill: "currentColor" });
}
export default XlIcon;
//# sourceMappingURL=Xl.js.map